import { motion } from "framer-motion";
import SceneShell from "../components/SceneShell";
import CountUp from "../components/CountUp";

/**
 * Scene 36 — What branches spend today.
 * Yellow theme — £30,000 on a videographer or social media manager.
 * "What do they actually get?" cards keep the warning yellow tint too.
 */

const GOLD = "#e9a820";
const GOLD_DEEP = "#d4940a";

export default function Scene36_CostToday() {
  return (
    <SceneShell variant="ink" align="left" data-testid="scene-cost-today">
      <motion.div
        className="absolute inset-0 pointer-events-none"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1.2 }}
        style={{
          background:
            "radial-gradient(ellipse at 70% 50%, rgba(212,148,10,0.20) 0%, transparent 55%)",
        }}
      />

      <div className="relative max-w-[1500px] mx-auto w-full">
        <motion.div
          initial={{ opacity: 0, y: 8 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          className="kn-eyebrow mb-6"
        >
          The reality today · per branch
        </motion.div>

        <motion.h2
          initial={{ opacity: 0, y: 24, filter: "blur(8px)" }}
          animate={{ opacity: 1, y: 0, filter: "blur(0px)" }}
          transition={{ duration: 1.0, delay: 0.2, ease: [0.16, 1, 0.3, 1] }}
          className="kn-display text-4xl sm:text-5xl lg:text-6xl text-white"
          data-testid="cost-today-title"
        >
          Let's just look at what branches
          <br />
          are <span style={{ color: GOLD }}>doing today.</span>
        </motion.h2>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-5">
          <CostCard
            label="Videographer"
            value={30000}
            note="Hiring full-time · annually"
            delay={0.6}
          />
          <CostCard
            label="Social media manager"
            value={30000}
            note="Or one of these · similar cost"
            delay={0.85}
            comparison
          />
        </div>
      </div>
    </SceneShell>
  );
}

function CostCard({ label, value, note, delay, comparison = false }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 24, scale: 0.95 }}
      animate={{ opacity: 1, y: 0, scale: 1 }}
      transition={{ duration: 0.9, delay, ease: [0.16, 1, 0.3, 1] }}
      className="rounded-2xl glass p-7 relative overflow-hidden"
      style={{
        border: `1px solid ${GOLD}33`,
      }}
    >
      <div
        className="absolute inset-0 rounded-2xl overflow-hidden pointer-events-none"
        aria-hidden="true"
      >
        <div
          className="absolute -bottom-12 -right-12 w-40 h-40 rounded-full opacity-30"
          style={{
            background: `radial-gradient(circle, ${GOLD} 0%, transparent 70%)`,
            filter: "blur(20px)",
          }}
        />
      </div>
      <div className="relative">
        <div
          className="text-[11px] tracking-[0.32em] uppercase mb-3"
          style={{ color: "rgba(255,255,255,0.55)" }}
        >
          {comparison ? "Or" : "Hiring"} · {label}
        </div>
        <div
          className="kn-display tnum text-[60px] sm:text-[72px] lg:text-[88px] leading-none whitespace-nowrap"
          style={{
            background: `linear-gradient(135deg, ${GOLD_DEEP} 0%, ${GOLD} 50%, ${GOLD_DEEP} 100%)`,
            WebkitBackgroundClip: "text",
            backgroundClip: "text",
            color: "transparent",
            fontWeight: 800,
          }}
        >
          <CountUp from={0} to={value} prefix="£" duration={2.0} startDelay={delay + 0.2} />
        </div>
        <div className="mt-3 text-sm" style={{ color: "rgba(255,255,255,0.55)" }}>
          {note}
        </div>
      </div>
    </motion.div>
  );
}
